import { useState, useCallback } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";
import Boot from "./components/Boot";
import Terminal from "./components/Terminal";
import Scene3D from "./components/Scene3D";
import ProjectPanel from "./components/ProjectPanel";
import ContactForm from "./components/ContactForm";
import Hud from "./components/Hud";
import ProjectInfoPage from "./pages/ProjectInfoPage";
import { Project } from "./data/projects";

type Phase = "boot" | "terminal" | "scene";

function CosmosApp() {
  const [searchParams] = useSearchParams();
  const startAtCosmos = searchParams.get("view") === "cosmos";
  const [phase, setPhase] = useState<Phase>(startAtCosmos ? "scene" : "boot");
  const [selected, setSelected] = useState<Project | null>(null);
  const [contactOpen, setContactOpen] = useState(false);
  const [graphReady, setGraphReady] = useState(false);

  const handleBootDone = useCallback(() => setPhase("terminal"), []);
  const handleRunReveal = useCallback(() => setPhase("scene"), []);
  const handleBackToTerminal = useCallback(() => {
    setSelected(null);
    setGraphReady(false);
    setPhase("terminal");
  }, []);
  const handleSelect = useCallback((p: Project) => setSelected(p), []);
  const handlePanelClose = useCallback(() => setSelected(null), []);
  const handleContactOpen = useCallback(() => setContactOpen(true), []);
  const handleContactClose = useCallback(() => setContactOpen(false), []);
  const handleGraphReady = useCallback(() => setGraphReady(true), []);

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {phase === "boot" && <Boot onDone={handleBootDone} />}
      {phase === "terminal" && <Terminal onRun={handleRunReveal} />}
      {phase === "scene" && (
        <>
          <Scene3D
            onSelect={handleSelect}
            selectedId={selected?.id}
            onReady={handleGraphReady}
          />
          <Hud
            ready={graphReady}
            onContact={handleContactOpen}
            onTerminal={handleBackToTerminal}
          />
          <ProjectPanel project={selected} onClose={handlePanelClose} />
        </>
      )}
      <ContactForm open={contactOpen} onClose={handleContactClose} />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/projects/:slug" element={<ProjectInfoPage />} />
      <Route path="*" element={<CosmosApp />} />
    </Routes>
  );
}
